import ContactBox from "./ContactBox";
import clock from '../../assets/icons/time.png';
import phone from '../../assets/icons/phone-call.png';

const ContactSection = ({ doctor }) => {

  if (!doctor) return <div className="w-full h-full flex justify-center items-center">
    درحال بارگذاری ...
  </div>

  return (
    <div>
      <h4 className="font-semibold flex gap-1 mt-5">
        <span>اطلاعات تماس</span>
        <span>{doctor.name}</span>
      </h4>

      {doctor.office_list.map((office) => (
        <div key={office.id} className="flex flex-col gap-2 p-3
        rounded-[10px]">
          <h5 className="">مطب {office.title}</h5>
          <div className="flex flex-col gap-1 sm:gap-0 sm:flex-row sm:justify-between">
            <ContactBox
            title={'شماره تماس'}
            sub={office.phone.join('\n')}
            icon={phone}
          />
          <ContactBox
            title={'ساعت کاری'}
            sub={office.work_time}
            icon={clock}
          />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactSection;
